import _ from 'lodash';
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import cn from 'classnames';
import * as Sentry from '@sentry/react';
import stringifyError from 'shared/lib/stringifyError';
import Logo from 'shared/components/Logo';
import { DEVELOPMENT_MODE } from 'shared/constants';
import styles from './FallbackScreen.module.scss';

const FallbackScreen = ({ error, standalone }) => {
  const { t } = useTranslation('common');

  useEffect(() => {
    if (DEVELOPMENT_MODE) {
      console.error(error);
    }

    if (standalone) {
      Sentry.captureException(_.isError(error) ? error : new Error(error));
    }
  }, []);

  const onReloadClick = (event) => {
    event.preventDefault();
    window.location.reload();
  };

  const onBackClick = (event) => {
    event.preventDefault();
    window.location.href = '/';
  };

  return (
    <>
      <section className={styles.header}>
        <div className="row">
          <div className="col-lg-12">
            <div className={cn('container', styles.headerContent)}>
              <a href="/"><Logo className={styles.logo} /><span>{t('name')}</span></a>
            </div>
          </div>
        </div>
      </section>
      <div className="container">
        <div className="row">
          <div className="col-12">
            <h1 className={styles.title}>
              <i className="la la-surprise" />
              {t('errorBoundary.title')}
            </h1>
          </div>
        </div>
        {DEVELOPMENT_MODE && (
          <div className={cn('row', styles.content)}>
            <div className="col-xl-6 offset-xl-3 col-lg-8 offset-lg-2 col-sm-12">
              <pre>{stringifyError(error, null, '\t')}</pre>
            </div>
          </div>
        )}
        <div className={cn('row', styles.content)}>
          <div className="col-12">
            <p>
              {t('errorBoundary.p1')}
            </p>
            <p>
              {t('errorBoundary.p2')}
            </p>
            <p>
              <a href="" onClick={onReloadClick}><i className="la la-redo-alt" />{t('errorBoundary.reloadPage')}</a>
              <span>|</span>
              <a href="" onClick={onBackClick}><i className="la la-undo" />{t('errorBoundary.backToHome')}</a>
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default FallbackScreen;
